import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CleanFiltersIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props}>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2.66797 3.33398H10.0013L14.668 8.00065L10.0013 12.6673H2.66797C2.31435 12.6673 1.97521 12.5268 1.72516 12.2768C1.47511 12.0267 1.33464 11.6876 1.33464 11.334V4.66732C1.33464 4.3137 1.47511 3.97456 1.72516 3.72451C1.97521 3.47446 2.31435 3.33398 2.66797 3.33398Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path d="M4 6L8 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
			<path d="M8 6L4 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	</SvgIcon>
);
